





































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import CenterAscendingStaffList from '@/staff/components/CenterAscendingStaffList.vue';
import {
    formatClockTime,
    formatDateForApi,
    formatIsoDateTime,
    getTimeZoneOptions
} from '@/date-time/date-time-utils';
import type { Family } from '@/families/models/family';
import type { Guardian } from '@/families/models/guardian';
import { searchByCenterId, searchByOrgId } from '@/families/search-families';
import { LocaleMixin } from '@/locales/locale-mixin';
import store from '@/store';
import { AuthStore } from '@/store/auth-store';
import DurationSelect from '@/tasks/components/DurationSelect.vue';
import TaskDescription from '@/tasks/components/TaskDescription.vue';
import TaskTypeSelect from '@/tasks/components/TaskTypeSelect.vue';
import { TaskCreateDto, TaskGroups, TaskReminderUnits, TaskType, TaskUpdateDto } from '@/tasks/models/task-models';
import { TasksPostPutRepository } from '@/tasks/repositories/tasks-post-put-repository';
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import TaskResultSelect from '@/tasks/components/TaskResultSelect.vue';
import StatusChangeSelect from '@/families/components/StatusChangeSelect.vue';
import SendReminderInputs from '@/tasks/components/SendReminderInputs.vue';
import { TasksRepository } from '@/tasks/repositories/tasks-repository';
import { ChangeStatus } from '@/families/change-status';
import { isDoNotEmail, isDoNotText, getChildAge } from '@/families/families-utils';
import { ChildUpdateDtoInterface } from '@/families/models/child';
import { ChildrenRepository } from '@/families/repositories/children-repository';
import { ChildMapper } from '@/families/mappers/child-mapper';
import { cloneDeep } from 'lodash';
import { AppStateStore } from '@/store/app-state-store';
import { enrollmentTeamPlaceholder } from '@/enrollment-center/models/enrollment-center-models';
import { TasksStore } from '@/tasks/stores/tasks-store';
import { isTaskPastDue } from '@/tasks/task-utils';
import { TimezoneOption } from '@/core/timezones/timezone';
import { FeaturesStore } from '@/features/features-store';
import { FeatureConstants } from '@/features/feature-constants';
import { CentersStore } from '@/organizations/locations/stores/centers-store';
import { TimezonesStore } from '@/core/timezones/timezones-store';
import { getAvatarBackgroundFromUser } from '@/core/avatar-utils';
import { downloadIcsFile } from '@/calendar/calendar-utils';
import { EventTypes } from '@/constants/event-type-constants';
import BaseClose from '@/components/base/BaseClose.vue';
import { PstToursAvailabilityTimeRange } from '@/pst-tours/models/pst-tours-availability';
import TaskGroupsService, { GroupedType } from '@/tasks/services/task-groups-service';
import { isTourInRange } from '@/pst-tours/pst-tours-utils';
import { ClientInfoStore } from '@/organizations/corporate/stores/client-info-store';
import TaskDueBar from '@/tasks/components/TaskDueBar.vue';
import { TaskDefaultsStore } from '@/tasks/stores/task-defaults-store';
import { LayoutTabsStore } from '@/store/layout-tabs-store';
import BaseDateInput from '@/components/base/BaseDateInput.vue';
import { TaskCreationService } from '@/tasks/services/task-creation-service';
import BulkAddTasksConfirmationModal from '@/tasks/components/BulkAddTasksConfirmationModal.vue';
import PositionBasedAssignSelect from '@/staff/components/PositionBasedAssignSelect.vue';
import { TabPermissions } from '@/core/tab-permissions';

const authState = getModule(AuthStore, store);
const childMapper = new ChildMapper();
const childrenRepo = new ChildrenRepository();
const tasksRepository = new TasksRepository();
const tasksStore = getModule(TasksStore);
const changeStatus = new ChangeStatus();
const appState = getModule(AppStateStore);
const featureState = getModule(FeaturesStore);
const centersState = getModule(CentersStore);
const timezoneState = getModule(TimezonesStore);
const taskGroupsService = new TaskGroupsService();
const clientInfoStore = getModule(ClientInfoStore);
const taskDefaultsStore = getModule(TaskDefaultsStore);
const layoutTabsStore = getModule(LayoutTabsStore, store);

@Component({
    components: {
        BaseClose,
        BaseDateInput,
        SendReminderInputs,
        DurationSelect,
        TaskTypeSelect,
        TaskDescription,
        CenterAscendingStaffList,
        PositionBasedAssignSelect,
        StatusChangeSelect,
        TaskResultSelect,
        TaskDueBar,
        BulkAddTasksConfirmationModal
    }
})
export default class AddTaskModal extends Mixins(LocaleMixin) {
    @Prop() readonly centerId!: number | undefined;
    @Prop() dueDateTime!: string;
    // Did somebody already tell us the family?
    @Prop() family!: Family | null;
    @Prop() initialDuration!: number | undefined;
    // Is this a meeting-type task?
    @Prop({ default: false }) isMeeting!: boolean;
    // v-model stuff
    @Prop({ default: false }) readonly value!: boolean;
    @Prop() readonly pstToursAvailabilityTimeRanges!: Array<PstToursAvailabilityTimeRange>;
    // Hide location and guardian fields for bulk task creation
    @Prop({ default: false }) hideFamilyFields!: boolean;
    @Prop() readonly filterId!: number;
    @Prop({ default: () => [] }) readonly familyIncludedIds!: Array<number>;
    @Prop({ default: () => [] }) readonly familyExcludedIds!: Array<number>;
    @Prop({ default: 0 }) readonly familyCount!: number;
    @Prop() readonly extraOrgId!: number;

    private familySelect: any = null;
    private familyId = 0;
    private defaultStaffId: any = null;
    private familySearchResults: Array<Family> | null | undefined = null;
    private familySearching = false;
    private familySelectItems: Array<any> = [];
    private familyInfo: Family | null | undefined = null;
    private searchDebounceTimer: number | null = null;
    private isNavigating = false;
    private selectedLocation: any = null;
    private locationItems: Array<any> = [];
    private taskType: any = null;
    private assignedTo: any = null;
    private assignToPosition: number | null = null;
    private centerIdStaff: any = null;
    private description = '';
    private exportToIcsFile = false;
    private startDate = '';
    private startTime = '';
    private isDisabled = true;
    private isSubsDisabled = true;
    private overlay = false;
    private taskAdded = false;
    private taskAddedMessage = '';
    private createAnotherText = '';
    private createNewText = '';
    private isTour = true;
    private sendTextReminderGuardian = false;
    private sendEmailReminderGuardian = false;
    private sendTextReminderStaff = false;
    private sendEmailReminderStaff = false;
    private duration = 60;
    private canEmail = true; // Is "email" reminder allowed?
    private canText = true; // Is "text" reminder allowed?
    private showCompleteOptions = false;
    private isComplete = false;
    private resultDescription = '';
    private result_type?: number | null;
    private commentsAdded = false;
    private guardianTextReminderAmount: string | null = null;
    private guardianTextReminderUnit: TaskReminderUnits | null = null;
    private guardianEmailReminderAmount: string | null = null;
    private guardianEmailReminderUnit: TaskReminderUnits | null = null;
    private staffTextReminderAmount: string | null = null;
    private staffTextReminderUnit: TaskReminderUnits | null = null;
    private staffEmailReminderAmount: string | null = null;
    private staffEmailReminderUnit: TaskReminderUnits | null = null;
    private isGuardianTextReminderValid = true;
    private isGuardianEmailReminderValid = true;
    private isStaffTextReminderValid = true;
    private isStaffEmailReminderValid = true;
    private chosenTimezone = 'UTC';
    private timezoneOptions: Array<TimezoneOption> = [];
    private showAllAccessible = false;
    private taskGroupedTypes: Array<GroupedType> = [];
    private taskGroup: GroupedType | undefined | null = null;
    private taskResultSelectKey = 0;
    private expansionPanelActive: number[] = [];
    public statusChangeSelectKey = 0;
    private loadVersion = 0;
    private statusChangeExpansionPanels: number[] = [];
    private completeNowExpansionPanel: number[] = [];
    private savedFamilyId: number | null = null;
    private savedFamilyName: string | null = null;
    private showBulkConfirmation = false;
    private pendingBulkTaskData: any = null;
    // DTOs for editing child data, separate from the original child objects to prevent
    // triggering StatusChangeSelect's deep watcher
    private childDtos: Array<ChildUpdateDtoInterface> = [];
    private originalChildDtos: Array<ChildUpdateDtoInterface> = [];

    async created() {
        if (!this.isSingleCenter && !this.family && this.isNewTaskModal) {
            await this.initializeLocations();
        }
        if (this.centerId) {
            this.centerIdStaff = this.centerId;
        }
        if (this.familyInfo && this.familyInfo.center) {
            this.centerIdStaff = this.familyInfo.center.id;
        }
        if (this.centerIdStaff) {
            const center = await centersState.getAccessibleCenterById(this.centerIdStaff);
            this.defaultStaffId = center.staff?.director?.id;
            if (this.isNewTaskModal && this.isMeeting && this.centerId) {
                this.selectedLocation = center;
            }
        }
        if (this.showLocationField) {
            await this.initializeLocations();
        }
    }

    async mounted() {
        if (this.isNewTaskModal) {
            this.initializeRemindersData();
        } else if (this.isMeeting) {
           this.initializeRemindersData();
        }

        if (this.dueDateTime) {
            this.updateDueDate();
        } else {
            this.startTime = '17:00';
        }

        if (this.initialDuration) {
            this.duration = this.initialDuration;
        }

        this.updateEmailReminderStaff();
        this.updateTextReminderStaff();
        if (!this.isNewTaskModal) {
            await featureState.init();
        }

        if (this.family) {
            await this.setFamily();
        }

        if (this.hideFamilyFields) {
            this.isSubsDisabled = false;
            this.isDisabled = false;
            if (!this.assignedTo) {
                this.assignedTo = this.defaultStaffId || authState.userInfoObject?.id;
            }
        }
        if (this.isNewTaskModal) {
            this.$nextTick(() => {
                this.setInitialFocus();
                this.removeClearIconTabFocus();
            });
            const version = ++this.loadVersion;
            this.loadAdditionalData(version);
        } else {
            if (this.showTimezone) {
                const centersPromise = centersState.initAccessibleCenters();
                const timezonePromise = timezoneState.init();
                await centersPromise;
                await timezonePromise;
                this.timezoneOptions = getTimeZoneOptions(timezoneState.stored, new Date(), this.$i18n.locale);
            }
            await taskGroupsService.init();
            this.showAllAccessible = !featureState.isFeatureEnabled(FeatureConstants.FRANCHISE_MODE);
            this.taskGroupedTypes = taskGroupsService.getTaskGroupedTypes();
        }
    }

    private async loadAdditionalData(version: number) {
        await featureState.init();

        if (this.showTimezone) {
            const centersPromise = centersState.initAccessibleCenters();
            const timezonePromise = timezoneState.init();
            await Promise.all([centersPromise, timezonePromise]);
            if (version !== this.loadVersion) { return; }
            this.timezoneOptions = getTimeZoneOptions(timezoneState.stored, new Date(), this.$i18n.locale);
        }

        await taskGroupsService.init();
        if (version !== this.loadVersion) { return; }
        this.showAllAccessible = !featureState.isFeatureEnabled(FeatureConstants.FRANCHISE_MODE);
        this.taskGroupedTypes = taskGroupsService.getTaskGroupedTypes();
    }

    private setInitialFocus() {
        if (this.family || this.hideFamilyFields) {
            const taskTypeElement = this.$el.querySelector('[data-cy="task-type"]');
            if (taskTypeElement) {
                (taskTypeElement as HTMLElement).focus();
            }
        } else {
            const familySearchElement = this.$el.querySelector('[data-cy="Guardian/Child"]');
            if (familySearchElement) {
                (familySearchElement as HTMLElement).focus();
            }
        }
    }

    private removeClearIconTabFocus() {
        const clearButtons = this.$el.querySelectorAll('.v-input__icon--clear button');
        clearButtons.forEach((btn: Element) => {
            (btn as HTMLElement).setAttribute('tabindex', '-1');
        });

        const observer = new MutationObserver(() => {
            const newClearButtons = this.$el.querySelectorAll('.v-input__icon--clear button');
            newClearButtons.forEach((btn: Element) => {
                if ((btn as HTMLElement).getAttribute('tabindex') !== '-1') {
                    (btn as HTMLElement).setAttribute('tabindex', '-1');
                }
            });
        });

        observer.observe(this.$el, {
            childList: true,
            subtree: true,
            attributes: false
        });
    }

    get modelValue(): boolean {
        // Use this, instead of direct property calling in the v-model above, or you will get an error.
        return this.value;
    }

    set modelValue(showIt: boolean) {
        // Emit, don't set the value. If you set it, you will get a direct property mutation error.
        this.$emit('input', showIt);
    }

    get descriptionLabel() {
        let label = 'Task';
        if (this.isMeeting) {
            label = 'Meeting';
        }
        return `${label} Description`;
    }

    get hasTextMessagingService() {
        return clientInfoStore.hasTextMessagingService;
    }

    get isLineLeaderEnroll(): boolean {
        return featureState.isLineLeaderEnroll;
    }

    get saveButtonText() {
        if (
            this.isMeeting &&
            (
                this.sendTextReminderGuardian ||
                this.sendEmailReminderGuardian ||
                this.sendTextReminderStaff ||
                this.sendEmailReminderStaff
            )
        ) {
            return 'Save and Send Reminder';
        }

        return 'Save';
    }

    get org() {
        return appState.storedCurrentOrg;
    }

    get taskTypeName(): string {
        if (!this.taskType) {
            return 'task';
        }
        const taskGroup = this.taskGroupedTypes.find((group) => group.typeId === this.taskType);
        return taskGroup ? taskGroup.typeValue.toLowerCase() : 'task';
    }

    get startTimeColumnWidth(): number {
      if (!this.showTimezone) {
        return 6;
      }

      if (!this.isAustralianLocale) {
        return 5;
      }

      return this.isLineLeaderEnroll ? 3 : 5;
    }

    get staffCenterId() {
        if (this.selectedLocation) {
            return this.selectedLocation.id;
        }
        if (this.centerId) {
            return this.centerId;
        }
        if (this.familyInfo && this.familyInfo.center) {
            return this.familyInfo.center.id;
        }
        if (this.userCenter) {
            return this.userCenter;
        }
        return null;
    }

    get showTimezone() {
        return featureState.isFeatureEnabled(FeatureConstants.CRM_PLUS_MODE);
    }

    get showPstToursAvailability() {
        return appState.displayPstAvailableHours;
    }

    get userTimezone() {
        return authState.userTimeZone;
    }

    get isNewTaskModal() {
        return featureState.isNewTaskModal;
    }

    private get isSingleCenter() {
        return centersState.count <= 1;
    }

    get showLocationField() {
        return !this.family;
    }

    get isGuardianFieldDisabled() {
        return !this.selectedLocation && !this.userCenter;
    }

    get userCenter(): number | undefined {
        return appState.storedCurrentCenter?.id;
    }

    get avatarSize() {
        return this.isSingleCenter ? '5em' : '6em';
    }

    get isOnFamilyHubPage(): boolean {
        return this.$route.name === 'family-hub';
    }

    get canAddCrmTabs(): boolean {
        return TabPermissions.canAddTabs();
    }

    get newTabStatus() {
        return appState.familyHubTargetMode;
    }

    get areFieldsDisabled() {
        if (this.hideFamilyFields === true) {
            return false;
        }
        return !this.familyInfo;
    }

    @Watch('dueDateTime')
    private updateDueDate() {
        this.startDate = formatDateForApi(this.dueDateTime);
        this.startTime = formatClockTime(this.dueDateTime);
    }

    @Watch('value')
    private async checkValue() {
      if (this.value) {
          if (this.isNewTaskModal && this.initialDuration && this.initialDuration > 0) {
              this.duration = this.initialDuration;
          }

          this.exportToIcsFile = false;
          this.initializeRemindersData();
          if (this.isNewTaskModal && this.isMeeting && this.centerId) {
              const center = await centersState.getAccessibleCenterById(this.centerId);
              this.selectedLocation = center;
          }
        }
    }

    @Watch('centerId')
    private centerChanged() {
        this.close();
    }

    @Watch('initialDuration')
    private onInitialDurationChanged() {
        if (this.initialDuration && this.initialDuration > 0) {
            this.duration = this.initialDuration;
        }
    }

    @Watch('family')
    private async setFamily() {
        if (this.isNewTaskModal) {
            this.familyInfo = this.family;
            this.familyId = this.family?.id ?? 0;
            this.initializeChildDtos(this.familyInfo);
            this.isSubsDisabled = false;
            this.canEmail = this.family ? !isDoNotEmail(this.family) : false;
            this.canText = this.family ? !isDoNotText(this.family) : false;
            this.applyDefaultsFromStore();
            if (!this.canEmail) {
                this.sendEmailReminderGuardian = false;
            }
            if (!this.canText) {
                this.sendTextReminderGuardian = false;
            }

            if (this.isMeeting) {
                if (this.sendTextReminderGuardian && !this.guardianTextReminderAmount) {
                    this.guardianTextReminderAmount = '2';
                    this.guardianTextReminderUnit = TaskReminderUnits.HOURS;
                }
                if (this.sendEmailReminderGuardian && !this.guardianEmailReminderAmount) {
                    this.guardianEmailReminderAmount = '24';
                    this.guardianEmailReminderUnit = TaskReminderUnits.HOURS;
                }
            }
            if (this.sendTextReminderStaff && !this.staffTextReminderAmount) {
                this.staffTextReminderAmount = '15';
                this.staffTextReminderUnit = TaskReminderUnits.MINUTES;
            }
            if (this.sendEmailReminderStaff && !this.staffEmailReminderAmount) {
                this.staffEmailReminderAmount = '10';
                this.staffEmailReminderUnit = TaskReminderUnits.HOURS;
            }

            if (this.showTimezone && this.familyInfo && this.familyInfo.center) {
                await this.setDefaultTimezone(this.familyInfo.center.id);
            }
        } else {
            this.familyInfo = this.family;
            this.familyId = this.family?.id ?? 0;
            this.initializeChildDtos(this.familyInfo);
            this.isSubsDisabled = false;
            this.canEmail = this.family ? !isDoNotEmail(this.family) : false;
            this.canText = this.family ? !isDoNotText(this.family) : false;
            if (this.isNewTaskModal) {
                this.applyDefaultsFromStore();
                if (!this.canEmail) {
                    this.sendEmailReminderGuardian = false;
                }
                if (!this.canText) {
                    this.sendTextReminderGuardian = false;
                }
            }

            if (this.showTimezone && this.familyInfo && this.familyInfo.center) {
                await this.setDefaultTimezone(this.familyInfo.center.id);
            }
        }

    }

    @Watch('familySelect')
    private async checkFamily() {
        if (this.hideFamilyFields) {
            return;
        }

        // Reset state when family changes
        this.familyInfo = null;
        this.familyId = 0;
        this.isTour = true;
        this.description = '';
        // Reset duration, and make sure it's not 0 FFS.
        if (!this.isNewTaskModal) {
            this.duration = this.initialDuration && this.initialDuration > 0
                ? this.initialDuration
                : 60;
        }
        // Reset task type
        if (!this.isMeeting) {
            this.taskType = undefined;
        }

        if (this.familySelect === null || typeof this.familySelect === 'undefined') {
            this.isSubsDisabled = true;
        }

        if (this.familySelect !== null && typeof this.familySelect !== 'undefined') {
            // Get the selected family.
            if (this.familySearchResults !== null && typeof this.familySearchResults !== 'undefined') {
                this.familyId = AddTaskModal.parseFamilyId(this.familySelect);
                this.familyInfo = this.familySearchResults.find(family => family.id === this.familyId);
                this.initializeChildDtos(this.familyInfo);
                this.isSubsDisabled = false;

                if (this.isNewTaskModal) {
                    this.applyDefaultsFromStore();
                }

                if (this.familyInfo?.do_not_email || !this.familyInfo?.primary_guardian.email) {
                    this.canEmail = false;
                    this.sendEmailReminderGuardian = false;
                }

                if (this.familyInfo?.do_not_text || !this.familyInfo?.primary_guardian.primary_phone?.number) {
                    this.canText = false;
                    this.sendTextReminderGuardian = false;
                }
                if (this.isNewTaskModal) {
                    if (this.isMeeting) {
                        if (this.sendTextReminderGuardian && !this.guardianTextReminderAmount) {
                            this.guardianTextReminderAmount = '2';
                            this.guardianTextReminderUnit = TaskReminderUnits.HOURS;
                        }
                        if (this.sendEmailReminderGuardian && !this.guardianEmailReminderAmount) {
                            this.guardianEmailReminderAmount = '24';
                            this.guardianEmailReminderUnit = TaskReminderUnits.HOURS;
                        }
                    }
                    if (this.sendTextReminderStaff && !this.staffTextReminderAmount) {
                        this.staffTextReminderAmount = '15';
                        this.staffTextReminderUnit = TaskReminderUnits.MINUTES;
                    }
                    if (this.sendEmailReminderStaff && !this.staffEmailReminderAmount) {
                        this.staffEmailReminderAmount = '10';
                        this.staffEmailReminderUnit = TaskReminderUnits.HOURS;
                    }
                }

                if (this.showTimezone && this.familyInfo && this.familyInfo.center) {
                    await this.setDefaultTimezone(this.familyInfo.center.id);
                }
            }
        } else if (this.familySelect === null || typeof this.familySelect === 'undefined') {
            // Clear out the previous search results.
            this.familySelectItems = [];
            // reset timezone
            this.chosenTimezone = this.userTimezone;
        }

        this.validate();
    }

    @Watch('taskType')
    private checkTaskTypeId() {
        this.validate();
    }

    @Watch('assignedTo')
    private checkAssignedTo() {
        this.validate();
    }

    @Watch('assignToPosition')
    private checkAssignToPosition() {
        this.validate();
    }

    @Watch('hideFamilyFields')
    private onHideFamilyFieldsChange() {
        if (this.hideFamilyFields) {
            this.isSubsDisabled = false;
            this.isDisabled = false;
            if (!this.assignedTo) {
                this.assignedTo = this.defaultStaffId || authState.userInfoObject?.id;
            }
            this.$nextTick(() => {
                this.validate();
            });
        }
    }

    @Watch('startDate')
    private checkStartDate() {
        this.validate();
    }

    @Watch('startTime')
    private checkStartTime() {
        this.validate();
    }

    @Watch('description')
    private checkDescription() {
        this.validate();
    }

    @Watch('isComplete')
    private checkCompletedTask() {
        this.validate();
    }

    @Watch('resultDescription')
    private checkResultDescription() {
        this.commentsAdded = this.resultDescription !== '';
        this.validate();
    }

    @Watch('isGuardianTextReminderValid')
    private checkGuardianTextReminderValid() {
        this.validate();
    }

    @Watch('isGuardianEmailReminderValid')
    private checkGuardianEmailReminderValid() {
        this.validate();
    }

    @Watch('isStaffTextReminderValid')
    private checkStaffTextReminderValid() {
        this.validate();
    }

    @Watch('isStaffEmailReminderValid')
    private checkStaffEmailReminderValid() {
        this.validate();
    }

    @Watch('sendTextReminderGuardian')
    private checkSendTextReminderGuardian() {
        this.validate();
    }

    @Watch('sendEmailReminderGuardian')
    private checkSendEmailReminderGuardian() {
        this.validate();
    }

    @Watch('sendTextReminderStaff')
    private checkSendTextReminderStaff() {
        this.validate();
    }

    @Watch('sendEmailReminderStaff')
    private checkSendEmailReminderStaff() {
        this.validate();
    }

    /**
     * Initialize child DTOs and clone for comparison to prevent triggering StatusChangeSelect's deep watcher
     */
    private initializeChildDtos(family: Family | null | undefined) {
        if (family && family.children) {
            this.childDtos = family.children.map(child => childMapper.toUpdateDto(child));
            this.originalChildDtos = cloneDeep(this.childDtos);
        }
    }

    private async setDefaultTimezone(centerId: number) {
        const matchingCenter = await centersState.getAccessibleCenterById(centerId);
        if (matchingCenter) {
            this.chosenTimezone = matchingCenter.timezone;
            return;
        }
        this.chosenTimezone = this.userTimezone;
    }

    private async initializeLocations() {
        await centersState.initAccessibleCenters();
        this.locationItems = centersState.storedAccessibleCenters;
    }

    private onLocationChange() {
        this.familySelect = null;
        this.familyInfo = null;
        this.familySelectItems = [];
    }

    private async doFamilySearch(searchString: string) {
        if (this.isNavigating) {
            this.isNavigating = false;
            return;
        }
        this.familySearching = false;
        this.familySelectItems = [];

        if (searchString && searchString !== '') {
            this.familySearching = true;
            const selectItems: Array<any> = [];

            // Do search, await results, update prop with results.
            this.familySearchResults = [];
            const searchCenterId = this.selectedLocation?.id || this.centerId;
            if (searchCenterId) {
                this.familySearchResults = await searchByCenterId(searchString, searchCenterId);
            } else if (this.org) {
                this.familySearchResults = await searchByOrgId(searchString, this.org.id);
            }

            this.familySearchResults.forEach((result) => {
                result.guardians.forEach((guardian) => {
                    selectItems.push({ text: guardian.name, value: result.id + '-g' + guardian.id });
                });

                result.children.forEach((child) => {
                    selectItems.push({ text: child.name, value: result.id + '-c' + child.id });
                });
            });

            this.familySelectItems = selectItems;
            this.familySearching = false;
        } else {
            this.familySelect = null;
        }
    }

    private handleFamilySearchKeyDown(event: KeyboardEvent) {
        const navKeys = ['ArrowUp', 'ArrowDown', 'Enter', 'Escape', 'Tab'];
        if (navKeys.includes(event.key)) {
            this.isNavigating = true;
        }
    }

    private avatarBackground(guardian: Guardian) {
        return guardian.id ? getAvatarBackgroundFromUser(guardian.id) : '';
    }

    private initializeRemindersData() {
        if (this.isNewTaskModal) {
            if (this.isMeeting) {
                const defs = taskDefaultsStore.meeting;
                if (defs) {
                    this.sendEmailReminderGuardian = this.canEmail ? defs.guardianEmailEnabled : false;
                    this.guardianEmailReminderAmount = defs.guardianEmailAmount !== null ? defs.guardianEmailAmount.toString() : '24';
                    this.guardianEmailReminderUnit = (defs.guardianEmailUnit as TaskReminderUnits) ?? TaskReminderUnits.HOURS;

                    this.sendTextReminderGuardian = this.canText ? defs.guardianTextEnabled : false;
                    this.guardianTextReminderAmount = defs.guardianTextAmount !== null ? defs.guardianTextAmount.toString() : '2';
                    this.guardianTextReminderUnit = (defs.guardianTextUnit as TaskReminderUnits) ?? TaskReminderUnits.HOURS;

                    this.sendEmailReminderStaff = defs.staffEmailEnabled;
                    this.staffEmailReminderAmount = defs.staffEmailAmount !== null ? defs.staffEmailAmount.toString() : '10';
                    this.staffEmailReminderUnit = (defs.staffEmailUnit as TaskReminderUnits) ?? TaskReminderUnits.HOURS;

                    this.sendTextReminderStaff = defs.staffTextEnabled;
                    this.staffTextReminderAmount = defs.staffTextAmount !== null ? defs.staffTextAmount.toString() : '15';
                    this.staffTextReminderUnit = (defs.staffTextUnit as TaskReminderUnits) ?? TaskReminderUnits.MINUTES;

                    this.exportToIcsFile = defs.addToCalendar;
                } else {
                    this.sendEmailReminderGuardian = this.canEmail;
                    this.sendTextReminderGuardian = this.canText;
                    this.sendEmailReminderStaff = true;
                    this.sendTextReminderStaff = true;
                    this.exportToIcsFile = false;
                    this.guardianTextReminderAmount = '2';
                    this.guardianTextReminderUnit = TaskReminderUnits.HOURS;
                    this.guardianEmailReminderAmount = '24';
                    this.guardianEmailReminderUnit = TaskReminderUnits.HOURS;
                    this.staffTextReminderAmount = '15';
                    this.staffTextReminderUnit = TaskReminderUnits.MINUTES;
                    this.staffEmailReminderAmount = '10';
                    this.staffEmailReminderUnit = TaskReminderUnits.HOURS;
                    this.updateEmailReminderStaff();
                    this.updateTextReminderStaff();
                }
            } else {
                const defs = taskDefaultsStore.task;
                if (defs) {
                    this.sendEmailReminderStaff = defs.staffEmailEnabled;
                    this.staffEmailReminderAmount = defs.staffEmailAmount !== null ? defs.staffEmailAmount.toString() : '10';
                    this.staffEmailReminderUnit = (defs.staffEmailUnit as TaskReminderUnits) ?? TaskReminderUnits.HOURS;

                    this.sendTextReminderStaff = defs.staffTextEnabled;
                    this.staffTextReminderAmount = defs.staffTextAmount !== null ? defs.staffTextAmount.toString() : '15';
                    this.staffTextReminderUnit = (defs.staffTextUnit as TaskReminderUnits) ?? TaskReminderUnits.MINUTES;
                } else {
                    // Set defaults for new task
                    this.sendEmailReminderStaff = true;
                    this.sendTextReminderStaff = true;
                    this.staffTextReminderAmount = '15';
                    this.staffTextReminderUnit = TaskReminderUnits.MINUTES;
                    this.staffEmailReminderAmount = '10';
                    this.staffEmailReminderUnit = TaskReminderUnits.HOURS;
                    this.updateEmailReminderStaff();
                    this.updateTextReminderStaff();
                }
            }
            // Only set default values if they haven't been set already (from store or defaults above)
            if (this.guardianTextReminderAmount === null) {
                this.guardianTextReminderAmount = this.sendTextReminderGuardian ? '2' : null;
                this.guardianTextReminderUnit = this.sendTextReminderGuardian ? TaskReminderUnits.HOURS : null;
            }
            if (this.staffTextReminderAmount === null) {
                this.staffTextReminderAmount = this.sendTextReminderStaff ? '15' : null;
                this.staffTextReminderUnit = this.sendTextReminderStaff ? TaskReminderUnits.MINUTES : null;
            }
            if (this.guardianEmailReminderAmount === null) {
                this.guardianEmailReminderAmount = this.sendEmailReminderGuardian ? '24' : null;
                this.guardianEmailReminderUnit = this.sendEmailReminderGuardian ? TaskReminderUnits.HOURS : null;
            }
            if (this.staffEmailReminderAmount === null) {
                this.staffEmailReminderAmount = this.sendEmailReminderStaff ? '10' : null;
                this.staffEmailReminderUnit = this.sendEmailReminderStaff ? TaskReminderUnits.HOURS : null;
            }
        } else {
            this.sendEmailReminderGuardian = this.isMeeting && this.canEmail;
            this.sendTextReminderGuardian = this.isMeeting && this.canText;
            this.sendEmailReminderStaff = this.isMeeting;
            this.sendTextReminderStaff = this.isMeeting;
            this.guardianTextReminderAmount = this.sendTextReminderGuardian ? '2' : null;
            this.guardianTextReminderUnit = this.sendTextReminderGuardian ? TaskReminderUnits.HOURS : null;
            this.staffTextReminderAmount = this.sendTextReminderStaff ? '15' : null;
            this.staffTextReminderUnit = this.sendTextReminderStaff ? TaskReminderUnits.MINUTES : null;
            this.guardianEmailReminderAmount = this.sendEmailReminderGuardian ? '24' : null;
            this.guardianEmailReminderUnit = this.sendEmailReminderGuardian ? TaskReminderUnits.HOURS : null;
            this.staffEmailReminderAmount = this.sendEmailReminderStaff ? '10' : null;
            this.staffEmailReminderUnit = this.sendEmailReminderStaff ? TaskReminderUnits.HOURS : null;
        }
    }

    private applyDefaultsFromStore() {
        if (this.isMeeting) {
            const defs = taskDefaultsStore.meeting;
            if (defs) {
                if (this.canEmail) {
                    this.sendEmailReminderGuardian = defs.guardianEmailEnabled;
                    this.guardianEmailReminderAmount = defs.guardianEmailAmount !== null ? defs.guardianEmailAmount.toString() : '24';
                    this.guardianEmailReminderUnit = defs.guardianEmailUnit as any || TaskReminderUnits.HOURS;
                }
                if (this.canText) {
                    this.sendTextReminderGuardian = defs.guardianTextEnabled;
                    this.guardianTextReminderAmount = defs.guardianTextAmount !== null ? defs.guardianTextAmount.toString() : '2';
                    this.guardianTextReminderUnit = defs.guardianTextUnit as any || TaskReminderUnits.HOURS;
                }
                this.sendEmailReminderStaff = defs.staffEmailEnabled;
                this.staffEmailReminderAmount = defs.staffEmailAmount !== null ? defs.staffEmailAmount.toString() : '10';
                this.staffEmailReminderUnit = defs.staffEmailUnit as any || TaskReminderUnits.HOURS;
                this.sendTextReminderStaff = defs.staffTextEnabled;
                this.staffTextReminderAmount = defs.staffTextAmount !== null ? defs.staffTextAmount.toString() : '15';
                this.staffTextReminderUnit = defs.staffTextUnit as any || TaskReminderUnits.MINUTES;
                this.exportToIcsFile = defs.addToCalendar;
            }
        } else {
            const defs = taskDefaultsStore.task;
            if (defs) {
                this.sendEmailReminderStaff = defs.staffEmailEnabled;
                this.staffEmailReminderAmount = defs.staffEmailAmount !== null ? defs.staffEmailAmount.toString() : '10';
                this.staffEmailReminderUnit = defs.staffEmailUnit as any || TaskReminderUnits.HOURS;
                this.sendTextReminderStaff = defs.staffTextEnabled;
                this.staffTextReminderAmount = defs.staffTextAmount !== null ? defs.staffTextAmount.toString() : '15';
                this.staffTextReminderUnit = defs.staffTextUnit as any || TaskReminderUnits.MINUTES;
            }
        }
    }

    private updateDefaultsInStore() {
        if (!this.modelValue) { return; }
        if (this.isMeeting) {
            const meetingDefaults = {
                guardianEmailEnabled: this.canEmail ? this.sendEmailReminderGuardian : false,
                guardianEmailAmount: this.canEmail && this.sendEmailReminderGuardian && this.guardianEmailReminderAmount !== null ? parseInt(this.guardianEmailReminderAmount) : null,
                guardianEmailUnit: this.canEmail && this.sendEmailReminderGuardian ? (this.guardianEmailReminderUnit as any) : null,
                guardianTextEnabled: this.canText ? this.sendTextReminderGuardian : false,
                guardianTextAmount: this.canText && this.sendTextReminderGuardian && this.guardianTextReminderAmount !== null ? parseInt(this.guardianTextReminderAmount) : null,
                guardianTextUnit: this.canText && this.sendTextReminderGuardian ? (this.guardianTextReminderUnit as any) : null,
                staffEmailEnabled: this.sendEmailReminderStaff,
                staffEmailAmount: this.sendEmailReminderStaff && this.staffEmailReminderAmount !== null ? parseInt(this.staffEmailReminderAmount) : null,
                staffEmailUnit: this.sendEmailReminderStaff ? (this.staffEmailReminderUnit as any) : null,
                staffTextEnabled: this.sendTextReminderStaff,
                staffTextAmount: this.sendTextReminderStaff && this.staffTextReminderAmount !== null ? parseInt(this.staffTextReminderAmount) : null,
                staffTextUnit: this.sendTextReminderStaff ? (this.staffTextReminderUnit as any) : null,
                addToCalendar: this.exportToIcsFile
            } as any;
            taskDefaultsStore.setMeetingDefaults(meetingDefaults);
        } else {
            const taskDefaults = {
                staffEmailEnabled: this.sendEmailReminderStaff,
                staffEmailAmount: this.sendEmailReminderStaff && this.staffEmailReminderAmount !== null ? parseInt(this.staffEmailReminderAmount) : null,
                staffEmailUnit: this.sendEmailReminderStaff ? (this.staffEmailReminderUnit as any) : null,
                staffTextEnabled: this.sendTextReminderStaff,
                staffTextAmount: this.sendTextReminderStaff && this.staffTextReminderAmount !== null ? parseInt(this.staffTextReminderAmount) : null,
                staffTextUnit: this.sendTextReminderStaff ? (this.staffTextReminderUnit as any) : null
            } as any;
            taskDefaultsStore.setTaskDefaults(taskDefaults);
        }
    }

    @Watch('sendTextReminderStaff')
    updateTextReminderStaff() {
        if (this.isNewTaskModal) {
            this.updateDefaultsInStore();
        } else {
            this.staffTextReminderAmount = this.sendTextReminderStaff ? '15' : null;
            this.staffTextReminderUnit = this.sendTextReminderStaff ? TaskReminderUnits.MINUTES : null;
        }
    }

    @Watch('sendEmailReminderStaff')
    updateEmailReminderStaff() {
        if (this.isNewTaskModal) {
            this.updateDefaultsInStore();
        } else {
        this.staffEmailReminderAmount = this.sendEmailReminderStaff ? '10' : null;
        this.staffEmailReminderUnit = this.sendEmailReminderStaff ? TaskReminderUnits.HOURS : null;
        }
    }

    @Watch('sendTextReminderGuardian')
    updateTextReminderGuardian() {
        if (this.isNewTaskModal) {
            this.updateDefaultsInStore();
        }
    }

    @Watch('sendEmailReminderGuardian')
    updateEmailReminderGuardian() {
        if (this.isNewTaskModal) {
            this.updateDefaultsInStore();
        }
    }

    @Watch('guardianTextReminderAmount')
    updateGuardianTextAmount() {
        if (this.isNewTaskModal) {
            this.updateDefaultsInStore();
        }
    }

    @Watch('guardianTextReminderUnit')
    updateGuardianTextUnit() {
        if (this.isNewTaskModal) {
            this.updateDefaultsInStore();
        }
    }

    @Watch('guardianEmailReminderAmount')
    updateGuardianEmailAmount() {
        if (this.isNewTaskModal) {
            this.updateDefaultsInStore();
        }
    }

    @Watch('guardianEmailReminderUnit')
    updateGuardianEmailUnit() {
        if (this.isNewTaskModal) {
            this.updateDefaultsInStore();
        }
    }

    @Watch('staffTextReminderAmount')
    updateStaffTextAmount() {
        if (this.isNewTaskModal) {
            this.updateDefaultsInStore();
        }
    }

    @Watch('staffTextReminderUnit')
    updateStaffTextUnit() {
        if (this.isNewTaskModal) {
            this.updateDefaultsInStore();
        }
    }

    @Watch('staffEmailReminderAmount')
    updateStaffEmailAmount() {
        if (this.isNewTaskModal) {
            this.updateDefaultsInStore();
        }
    }

    @Watch('staffEmailReminderUnit')
    updateStaffEmailUnit() {
        if (this.isNewTaskModal) {
            this.updateDefaultsInStore();
        }
    }

    @Watch('exportToIcsFile')
    updateExportToIcsFile() {
        if (this.isNewTaskModal && this.isMeeting) {
            this.updateDefaultsInStore();
        }
    }

    private static parseFamilyId(id: string) {
        const fId = id.split('-')[0];
        return parseInt(fId);
    }

    private async setTaskType(taskType: TaskType) {
        if (taskType && taskType.id) {
            this.taskType = taskType.id;
            this.taskGroup = this.taskGroupedTypes.find((group) => group.typeId === this.taskType);
        }
        if (!this.showCompleteOptions) {
            if (!this.isSubsDisabled) { this.showCompleteOptions = !this.showCompleteOptions; }
        }
    }

    private updateDuration(duration: number) {
        this.duration = duration;
    }

    private avatarInitials(guardian: Guardian) {
        const firstName = guardian.first_name || '';
        const lastName = guardian.last_name || '';
        return firstName.substring(0, 1).toUpperCase() + lastName.substring(0, 1).toUpperCase();
    }

    private validate(): boolean {
        this.isDisabled = true;
        // Check reminder validations only for new task modal - same pattern as ManageTaskModal
        let areRemindersValid = true;
        if (this.isNewTaskModal) {
            const guardianTextValid = !this.sendTextReminderGuardian || this.isGuardianTextReminderValid;
            const guardianEmailValid = !this.sendEmailReminderGuardian || this.isGuardianEmailReminderValid;
            const staffTextValid = !this.sendTextReminderStaff || this.isStaffTextReminderValid;
            const staffEmailValid = !this.sendEmailReminderStaff || this.isStaffEmailReminderValid;
            areRemindersValid = guardianTextValid && guardianEmailValid && staffTextValid && staffEmailValid;
        }

        // When hideFamilyFields is true, we don't require a family to be selected
        const familyRequired = this.hideFamilyFields ? false : this.familyId > 0;
        const bulkRequirementsValid = this.hideFamilyFields ? !!this.filterId : true;
        const assignmentValid = this.hideFamilyFields
            ? (!this.userCenter
                ? (typeof this.assignToPosition !== 'undefined' && this.assignToPosition !== null)
                : (typeof this.assignedTo !== 'undefined' && this.assignedTo !== null && this.assignedTo !== ''))
            : (typeof this.assignedTo !== 'undefined' && this.assignedTo !== null && this.assignedTo !== '');

        if ((familyRequired || this.hideFamilyFields) &&
            bulkRequirementsValid &&
            typeof this.taskType !== 'undefined' &&
            this.taskType !== null &&
            this.taskType !== '' &&
            assignmentValid &&
            typeof this.startDate !== 'undefined' &&
            this.startDate !== '' &&
            typeof this.startTime !== 'undefined' &&
            this.startTime !== '' &&
            ((!this.commentsAdded && !this.isComplete) || (this.commentsAdded && this.isComplete) || (!this.commentsAdded && this.isComplete)) &&
            areRemindersValid
        ) {
            this.isDisabled = false;
            return true;
        }

        return false;
    }

    private async saveTask() {
        this.isDisabled = true;

        if (this.validate()) {
            this.overlay = true;

            try {
                const tasksPostPutRepository = new TasksPostPutRepository();
                const timeZone = this.showTimezone ? this.chosenTimezone : this.userTimezone;
                const dueDateFormatted = formatIsoDateTime(this.startDate + ' ' + this.startTime, timeZone);

                if (this.hideFamilyFields) {
                    if (!this.filterId) {
                        this.isDisabled = false;
                        this.overlay = false;
                        return;
                    }

                    const taskCreationData = {
                        taskType: this.taskType,
                        description: this.description,
                        startDate: this.startDate,
                        startTime: this.startTime,
                        assignToPosition: this.assignToPosition ?? undefined,
                        assignedTo: this.assignedTo,
                        sendEmailReminderStaff: this.sendEmailReminderStaff,
                        sendTextReminderStaff: this.sendTextReminderStaff,
                        showTimezone: this.showTimezone,
                        chosenTimezone: this.chosenTimezone,
                        userTimezone: this.userTimezone,
                        familyIncludedIds: this.familyIncludedIds,
                        familyExcludedIds: this.familyExcludedIds
                    };

                    this.pendingBulkTaskData = taskCreationData;
                    this.showBulkConfirmation = true;
                    this.isDisabled = true;
                    this.overlay = true;
                    return;
                }

                const task: TaskCreateDto = {
                    family: this.familyId,
                    type: this.taskType,
                    assigned_to_staff: this.assignedTo,
                    due_date_time: dueDateFormatted,
                    description: this.description ? this.description : ''
                };

                if (task.assigned_to_staff === enrollmentTeamPlaceholder) {
                    task.assigned_to_staff = 0;
                    task.assigned_to_enrollment_team_group = 1;
                }

                // Set meeting-related stuff
                if (this.isMeeting) {
                    task.duration = this.duration;
                    if (this.sendEmailReminderGuardian) {
                        task.primary_guardian_email_reminder_amount = this.guardianEmailReminderAmount !== null ? parseInt(this.guardianEmailReminderAmount) : null;
                        task.primary_guardian_email_reminder_unit = this.guardianEmailReminderUnit !== null ? this.guardianEmailReminderUnit : null;
                    }
                    if (this.sendTextReminderGuardian) {
                        task.primary_guardian_text_reminder_amount = this.guardianTextReminderAmount !== null ? parseInt(this.guardianTextReminderAmount) : null;
                        task.primary_guardian_text_reminder_unit = this.guardianTextReminderUnit !== null ? this.guardianTextReminderUnit : null;
                    }
                }
                if (this.sendEmailReminderStaff) {
                    task.staff_email_reminder_amount = this.staffEmailReminderAmount !== null ? parseInt(this.staffEmailReminderAmount) : null;
                    task.staff_email_reminder_unit = this.staffEmailReminderUnit !== null ? this.staffEmailReminderUnit : null;
                }

                if (this.sendTextReminderStaff) {
                    task.staff_text_reminder_amount = this.staffTextReminderAmount !== null ? parseInt(this.staffTextReminderAmount) : null;
                    task.staff_text_reminder_unit = this.staffTextReminderUnit !== null ? this.staffTextReminderUnit : null;
                }
                if (isTaskPastDue(task) && this.isMeeting) {
                    tasksStore.incrementPastDueToursWithin30DaysCount();
                }

                if (this.isMeeting && this.showPstToursAvailability && this.pstToursAvailabilityTimeRanges && this.pstToursAvailabilityTimeRanges.length > 0) {
                    const pstToursAvailabilityTimeRangeInIso: Array<PstToursAvailabilityTimeRange> = this.pstToursAvailabilityTimeRanges
                        .map((range: PstToursAvailabilityTimeRange): PstToursAvailabilityTimeRange => {
                        return {
                            start_datetime: formatIsoDateTime(range.start_datetime, timeZone),
                            end_datetime: formatIsoDateTime(range.end_datetime, timeZone)
                        };
                    });
                    const taskGroupType = this.taskGroupedTypes.find((group) => group.groupId === TaskGroups.TOURS && group.typeId === this.taskType);
                    const isTourGroup = !!taskGroupType;
                    const isTourInAvailableRanges = isTourInRange(pstToursAvailabilityTimeRangeInIso, task.due_date_time, task.duration ?? 0);
                    if (isTourGroup && !isTourInAvailableRanges) {
                        const tourType = taskGroupType?.typeValue;
                        const result = await this.$swal({
                            text: `You are about to book a ${tourType} outside of regular tour hours. Do you wish to proceed?`,
                            showConfirmButton: true,
                            showCancelButton: true,
                            confirmButtonText: 'Yes',
                            cancelButtonText: 'No'
                        });
                        if (!result.isConfirmed) {
                            return;
                        }
                    }
                }

                const newTask = await tasksPostPutRepository.addTask(task);
                if (this.familyInfo) {
                    this.savedFamilyId = this.familyInfo.id;
                    this.savedFamilyName = this.familyInfo.primary_guardian.last_name;
                }

                if (this.isNewTaskModal) {
                    this.updateDefaultsInStore();
                }
                if (this.isMeeting && this.exportToIcsFile) {
                    downloadIcsFile(newTask);
                }
                if (this.family) {
                    // Save child birth date changes if modified (only when birth date fields are shown)
                    if (this.childDtos.length > 0) {
                        for (let i = 0; i < this.childDtos.length; i++) {
                            if (this.childDtos[i].date_of_birth !== this.originalChildDtos[i].date_of_birth) {
                                await childrenRepo.update(this.family.id, this.childDtos[i]);
                            }
                        }
                    }
                    await changeStatus.writePendingChanges(this.family.id);
                }
                // If task needs to be recorded as completed
                if (this.isComplete) {
                    const taskId = newTask.id;
                    const updateTask: TaskUpdateDto = {
                        id: taskId,
                        family: this.familyId,
                        type: this.taskType,
                        assigned_to_staff: this.assignedTo,
                        due_date_time: dueDateFormatted,
                        description: this.description ? this.description : '',
                        is_completed: true,
                        completed_by_user_id: authState.userInfoObject?.id,
                        completed_date_time: formatIsoDateTime(new Date()),
                        result_type: this.result_type,
                        result_description: this.resultDescription
                    };
                    const completedTask = await tasksRepository.complete(updateTask);
                    if (this.isMeeting && this.exportToIcsFile) {
                        downloadIcsFile(completedTask);
                    }
                    // Note: Birth date changes and status changes were already saved above (lines 2231-2241)
                }

                this.$emit('created', newTask);
                this.close();
                this.$nextTick(() => {
                    if (this.isNewTaskModal) {
                        this.taskAddedMessage = this.isMeeting ? 'Meeting Saved' : 'Task Saved';
                        this.createAnotherText = this.isMeeting ? 'Create Another Meeting' : 'Create Another Task';
                        this.createNewText = this.isMeeting ? 'Create a New Task' : 'Create a New Meeting';
                    }
                    this.taskAdded = true;
                });
            } catch (e) {
                this.isDisabled = false;
                this.overlay = false;
            }
        }
    }

    // Close the modal and clean up some stuff.
    private close() {
        this.familySelect = null;
        this.familyId = this.family ? this.family.id : 0;
        this.familySearchResults = null;
        this.familySearching = false;
        this.familySelectItems = [];
        this.familyInfo = this.family; // often null
        this.selectedLocation = null;
        this.taskType = null;
        this.assignedTo = null;
        this.description = '';
        this.duration = 60;
        this.startDate = '';
        this.startTime = '17:00';
        this.isSubsDisabled = this.hideFamilyFields ? false : !this.family;
        this.isDisabled = true;
        this.overlay = false;
        this.showCompleteOptions = false;
        this.isComplete = false;
        this.exportToIcsFile = false;
        this.resultDescription = '';
        this.result_type = null;
        changeStatus.resetQueue(this.familyId);
        this.commentsAdded = false;
        this.modelValue = false;
        this.taskResultSelectKey++;
        this.expansionPanelActive = [];
        this.completeNowExpansionPanel = [];
        this.statusChangeSelectKey++;
        this.$emit(EventTypes.CLOSE);
    }

    private handleBulkCancel() {
        this.showBulkConfirmation = false;
        this.isDisabled = false;
        this.overlay = false;
    }

    private async handleBulkBegin() {
        if (!this.pendingBulkTaskData || !this.filterId) {
            return;
        }

        this.showBulkConfirmation = false;
        this.overlay = true;
        this.isDisabled = true;

        try {
            const taskCreationService = new TaskCreationService();
            const result = await taskCreationService.createGroupTask(this.filterId, this.pendingBulkTaskData);
            this.$emit('bulk-task-created', result);
            this.close();
            this.$nextTick(() => {
                this.taskAddedMessage = 'Tasks created successfully.';
                this.taskAdded = true;
            });
        } catch (e) {
            this.isDisabled = false;
            this.overlay = false;
        } finally {
            this.pendingBulkTaskData = null;
        }
    }

    private setTaskResult(result: number|undefined) {
        this.result_type = result;
        this.isComplete = result !== undefined;

        // Set start date and start time
        this.startDate = formatDateForApi(new Date());
        this.startTime = formatClockTime(new Date());
    }

    private shouldTruncate(text: string | null | undefined, maxLength = 40): boolean {
        if (!text) return false;
        const charCount = text.trim().length;
        return charCount > maxLength;
    }

    private dropdownFunc() {
        if (!this.isSubsDisabled) { this.showCompleteOptions = !this.showCompleteOptions; }
    }

    private formatIsoDateTime(dateTime: string, timezone: string): string {
        return formatIsoDateTime(dateTime, timezone);
    }

    getChildAge(child: any): string {
        return getChildAge(child);
    }

    getChildName(child: any): string {
        return child.name || `${child.first_name} ${child.last_name}`;
    }

    isChildNameTruncated(child: any): boolean {
        const childName = this.getChildName(child);
        return childName.length > 20;
    }

    private handleCreateAnother() {
        this.taskAdded = false;
        const familyInfo = this.familyInfo || (this.savedFamilyId ? { id: this.savedFamilyId } as any : null);
        if (this.isMeeting) {
            this.$emit(EventTypes.MEETING_ADD, familyInfo);
        } else {
            this.$emit(EventTypes.TASK_ADD_ANOTHER, familyInfo);
        }
    }

    private handleCreateNew() {
        this.taskAdded = false;
        const familyInfo = this.familyInfo || (this.savedFamilyId ? { id: this.savedFamilyId } as any : null);
        if (this.isMeeting) {
            this.$emit(EventTypes.TASK_ADD_ANOTHER, familyInfo);
        } else {
            this.$emit(EventTypes.MEETING_ADD, familyInfo);
        }
    }

    private async handleGoToFamily() {
        this.taskAdded = false;
        const familyId = this.familyInfo?.id || this.savedFamilyId;
        const familyName = this.familyInfo?.primary_guardian.last_name || this.savedFamilyName || 'Family';

        if (!familyId) {
            return;
        }

        if (this.newTabStatus) {
            if (this.canAddCrmTabs) {
                await layoutTabsStore.addTab({
                    routeName: 'family-hub',
                    routeParams: { id: familyId.toString() },
                    goTo: true,
                    tabTitle: familyName
                });
            } else {
                const routeData = this.$router.resolve({
                    name: 'family-hub',
                    params: { id: familyId.toString() }
                });
                window.open(routeData.href, '_blank');
            }
        } else {
            await this.$router.push({
                name: 'family-hub',
                params: { id: familyId.toString() }
            });
        }
    }
};
